<template>
	<label :for="status">
		<span v-if="nome === null"> Status: </span>
		<span v-else> {{ nome }} </span>
		<input type="checkbox" name="status" id="status" :disabled='disabled' @change="checkStatusChange" :checked="checked" />
		<span class="box">
			<i class="fas fa-check"></i>
		</span>
	</label>
</template>

<script>
export default {
	name: 'StatusCheck',
	props: ['checked', 'disabled', 'status', 'nome'],
	model: {
		prop: 'checked',
		event: 'change'
	},
	methods: {
		checkStatusChange (value) {
			this.$emit('change', value)
		}
	}
}
</script>

<style lang="scss" scoped>
label {
	display: flex;
	align-items: center;
	cursor: pointer;
	font-weight: $font-weight-default-bolder;
	font-family: $font-family;
	color: $font-color;
	font-size: 1em;

	input[type=checkbox] {
		display: none;

		&:checked + span.box {
			background-color: $success-color;
		}

		&:checked + span.box i {
			opacity: 1;
		}

		&:checked + span.box::after {
			content: 'Ativo'
		}
	}

	.box {
		width: 24px;
		height: 24px;
		border-radius: 4px;
		background-color: #fff;
		margin-left: 14px;
		transition: background 300ms ease;
		border: .6px solid $success-color;
		display: flex;

		i {
			opacity: 0;
			color: #fff;
			transition: opacity 300ms ease-in;
			margin: 3px 0 0 3px;
		}

		&:hover {
			background-color: $success-color;
		}

		&::after {
			content: 'Inativa';
			margin: -3px 0 0 14px;
			font-size: .9em;
			position: relative;
		}
	}
}
</style>
